import { render } from "./BHTabHeader.vue?vue&type=template&id=18b9eec8&scoped=true&lang=pug"
import script from "./BHTabHeader.vue?vue&type=script&lang=js"
export * from "./BHTabHeader.vue?vue&type=script&lang=js"

import "./BHTabHeader.vue?vue&type=style&index=0&id=18b9eec8&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b9eec8"]])

export default __exports__